module.exports = __webpack_public_path__ + "static/media/avatar_17.cfaa7c64.svg";